export function setLocation(data){
    sessionStorage.setItem('location',data)
}

export function getLocation(){
    return sessionStorage.getItem('location') || ''
}


const platformId = "platformId"

export function getMainPlatform () {
    return localStorage.getItem('platformId') || ''
}

export function setMainPlatform(data) {
    localStorage.setItem('platformId', data)
}



